// extracted by mini-css-extract-plugin
export default {"custom-navbar":"NavbarLogo_custom-navbar__-RlmA","logo-container":"NavbarLogo_logo-container__kCzny","logo":"NavbarLogo_logo__ifcRI","activeLink":"NavbarLogo_activeLink__tT+C6"};